// Transaction Contants
export const GET_TRANSACTIONS_REQUEST = "GET_TRANSACTIONS_REQUEST";
export const GET_TRANSACTIONS_SUCCESS = "GET_TRANSACTIONS_SUCCESS";
export const GET_TRANSACTIONS_FAIL = "GET_TRANSACTIONS_FAIL";

export const GET_AGENT_TRANSACTIONS_REQUEST = "GET_AGENT_TRANSACTIONS_REQUEST";
export const GET_AGENT_TRANSACTIONS_SUCCESS = "GET_AGENT_TRANSACTIONS_SUCCESS";
export const GET_AGENT_TRANSACTIONS_FAIL = "GET_AGENT_TRANSACTIONS_FAIL";
